import { requestStatusLabelHelper } from 'helpers'

export const mapRequests = (requests) => requests.map((request) => ({
  ...request,
  statusId: request.status,
  tabe_number: request.table.number,
  status: requestStatusLabelHelper(request.status),
  total_price: request.total_price.toFixed(2)
}))
